import { render } from "./LibraryView.vue?vue&type=template&id=8072de9e"
import script from "./LibraryView.vue?vue&type=script&lang=js"
export * from "./LibraryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__